import { useGetApproveitAiIntegrationData } from '@queries/Integration/ApproveitAI'

const useGetIsApproveitAIConnected = () => {
  const { data, isLoading } = useGetApproveitAiIntegrationData()

  return { isConnected: !!data, isLoading: isLoading }
}

export default useGetIsApproveitAIConnected
